import { createSlice } from "@reduxjs/toolkit";
import { iBillingListItem, REDUCER_NAME } from "./Types";
import { getBillingDetailsList } from "./ThunkAction";

interface iBillingState {
  isLoading: boolean;
  billingList: iBillingListItem[];
  selectedBilling?: iBillingListItem;
  errorMessage: string | null;
}

const initialState: iBillingState = {
  isLoading: false,
  billingList: [],
  selectedBilling: undefined,
  errorMessage: null,
};

export const getbillingSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetProductState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBillingDetailsList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getBillingDetailsList.fulfilled, (state, action) => {
       state.billingList = action.payload?.data || [];
       state.isLoading = false;
      })
      
      .addCase(getBillingDetailsList.rejected, (state, action) => {
        state.errorMessage = (action.payload as { message?: string })?.message || "Failed to fetch products";
        state.isLoading = false;
      })

        },
  
});

export const { resetProductState } = getbillingSlice.actions;
export default getbillingSlice.reducer;